import React from "react";
import {
  Accordion,
  AccordionDetails,
  Grid,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Checkbox,
} from "@mui/material";

import styles from "../../JobBatch.module.css";
import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";

// const batchData = [
//     {

//         "jobDetails": [
//             {
//                 City: "Lucknow",
//                 address1: "Novalpetal | Flower Lab",
//                 address2: "Plot - 34, Village Name, Lucknow, UP - 190734",
//                 storeManagerName: "Krupa Patel",

//                 driverVehicleNumber: "HR53KH5432",
//                 driverName: "Tamesh",
//                 jobDate: "21 Sep 24",
//                 jobPay: 960,
//                 AllotedTime: "21 Sep 24-25 Oct 24",
//                 LotNo: "Lot-35",
//                 SiteReport: "File",
//                 Action: ""

//             },

//             // Add more job details here if needed
//         ]
//     },

// ]

const Available = ({
  availableJobs,
  selectedJobs,
  selectAll,
  setSelectAll,
  setSelectedJobs,
}) => {
  console.log("selectedJos", selectedJobs);
  const handleSelectJob = (job) => {
    console.log(job);
    setSelectedJobs((prevSelected) => {
      const isAlreadySelected = prevSelected.find(
        (item) => item._id === job._id
      );

      if (isAlreadySelected) {
        return prevSelected.filter((item) => item._id !== job._id);
      } else {
        return [...prevSelected, job];
      }
    });
  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedJobs(availableJobs); // Directly store all job objects
      setSelectAll(true);
    } else {
      setSelectedJobs([]);
      setSelectAll(false);
    }
  };
  // const [expandedBatch, setExpandedBatch] = React.useState(null);

  // const handleAccordionToggle = (batchTitle) => (event) => {
  //   event.stopPropagation();
  //   setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  // };

  // const handleMoreClick = (event, batchTitle) => {
  //   event.stopPropagation(); // Prevent accordion toggle
  //   console.log(`More options for ${batchTitle}`);
  // };

  return (
    <Grid className={`${styles.scrollableContainer}`}>
      <Grid item xs={12} md={12} my={1} mx={2}>
        {/* Check if availableJobs is empty */}
        {availableJobs.length === 0 ? (
          <Box className={styles.noJobsBox}>
            <p className={styles.noJobsText}>No jobs are available</p>
          </Box>
        ) : (
          <Accordion>
            <AccordionDetails className={styles.accordionDetails}>
              {/* Render Job Details Table */}
              <Box className={`${styles.scrollableBox}`}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow className={styles.tableHeader}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={
                              selectAll ||
                              availableJobs?.length === selectedJobs?.length
                            } // This will check if all jobs are selected
                            onChange={handleSelectAll} // Toggle select/unselect all jobs
                          />
                        </TableCell>
                        <TableCell className={styles.tableCell}>CITY</TableCell>
                        <TableCell className={styles.tableCell}>
                          ADDRESS
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          STORE MANAGER
                        </TableCell>

                        <TableCell className={styles.tableCell}>
                          JOB DATE
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          Job Pay
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          ALLOTED TIME
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          LOT NO
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          SITE REPORT
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          ACTION
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {availableJobs.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={selectedJobs?.some(
                                (item) => item?._id === row._id
                              )}
                              onChange={() => handleSelectJob(row)} // When clicked, select/unselect individual job
                            />
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.city}
                            </div>
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.address}
                            </div>
                            <div className={styles.address2}>
                              {row.address2}
                            </div>
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.storeOwnerName}
                            </div>
                            <div className={styles.storeManagerContact}>
                              {row.storeOwnerPhoneNumber}
                            </div>
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.jobDate}
                            </div>
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              ₹{row.jobPay}
                            </div>
                          </TableCell>

                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.AllotedTime}
                            </div>
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.LotNo}
                            </div>
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            <div className={styles.linkWithImage}>
                              <img
                                src={PdfIcon}
                                alt="PDF Icon"
                                className={styles.icon}
                              />
                              <a href="#" className={styles.link}>
                                {row.SiteReport}
                              </a>
                            </div>
                          </TableCell>
                          <TableCell>
                            <button className={styles.editButton}>Edit</button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </AccordionDetails>
          </Accordion>
        )}
      </Grid>
    </Grid>
  );
};

export default Available;
